<template>
  <div id="header_container">
    <div id="header">
      <router-link to="/">
        <img id="logo" alt="logo" src="@/assets/header_logo.png" />
      </router-link>
      <NavItem
        v-for="(item, index) in items"
        :toPath="item.path"
        :title="item.title"
        :key="`item_${index}`"
      />
    </div>
  </div>
  <hr />
</template>

<script>
import NavItem from "./NavItem.vue";

export default {
  name: "Nav",
  components: {
    NavItem,
  },
  props: {
    list: Array,
  },
  methods: {
  },
  data() {
    return {
      moveIndex: 1,
      moveColor: "#666",
      items: [
        {
          path: "/introduce",
          title: "集团介绍",
        },
        {
          path: "/guinong",
          title: "何谓归农",
        },
        {
          path: "/news",
          title: "新闻动态",
        },
        {
          path: "/farming",
          title: "自然农法",
        },
        {
          path: "/recruitment",
          title: "人才招聘",
        },
        {
          path: "/mallApp",
          title: "下载App",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

#header_container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(5px);
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.05);
  width: 100%;
}

#header {
  height: 89px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 960px;
}

img {
  height: 39px;
  width: 65px;
  margin-right: 30px;
}

hr {
  margin: 0;
  width: 100%;
  border: 0;
  border-top: 1px solid #99999966;
}
</style>